import ArticleTemplate from '@/pages/article/components/ArticleTemplate';

export default function ArticleLegit() {
  return <ArticleTemplate slug="is-sugargoo-legit" />;
}